@if (gamesSearch.showFiltersBar) {
  <form [ngClass]="{'gradient-filter': isFirefox, 'card-gradient' : !isFirefox}" (ngSubmit)="onSubmit()" [formGroup]="gamesFilter.form">
    <div class="filters-container">
      <div class="filters-container__categories">
        <div class="filters-container__title">{{'link.categories' | translate}}</div>
        <div>
          <app-multi-checkbox
            formControlName="category[]"
            [withGrid]="true"
            [options]="(categories$ | async) || []"
          ></app-multi-checkbox>
        </div>
      </div>
      <div class="filters-container__providers">
        <div class="filters-container__title">{{'link.providers' | translate}}</div>
        <app-multi-checkbox
          formControlName="provider[]"
          [withGrid]="true"
          [options]="(providers$ | async) || []"
        ></app-multi-checkbox>
      </div>
      <div class="filters-container__actions">
        <button (click)="onCancel()" class="btn small" type="button">{{'btn.cancel' | translate}}</button>
        <button class="btn small" type="submit">{{'t.apply' | translate}}</button>
      </div>
    </div>
  </form>
}
